import Grid from '../../../component/form/Grid';
import Checkbox from '../../../component/form/Checkbox';
import TextField from '../../../component/form/TextField';
import RadioGroup from '../../../component/form/RadioGroup';
import {
    VALUABLES_LOCATION_OPTIONS,
    VALUABLES_LOCATION_QUESTIONS,
    VALUABLES_RETURN_OPTIONS
} from '../../funeral/details/valuables-modal/ValuablesConstants';
import OptionalTextField from '../../../component/form/OptionalTextField';
import React from 'react';
import Select from '../../../component/form/Select';
import { StepperStep, StepperStepLabel } from '../../../component/form/Stepper';
import { niceDateTimeFromString } from '../../../util/date';
import withStyles from '@mui/styles/withStyles';
import { Stepper } from '@mui/material';
import { joinDefined } from '../../../util/strings';
import Label from '../../../component/form/Label';

export function convertLegacyValuablesNotes(data) {
    // note that after a save only changes are returned, so some of this data might be undefined...
    const node = { ...data };
    const toBePlaced = node.ToBePlaced;
    const toBeReturned = node.ToBeReturned;
    const toReturn =
        'Return' === node.FinalAction ||
        !!node.ToBeReturned ||
        (node.Note && node.Note.toLowerCase().includes('return'));
    if (undefined !== data.Note) {
        data.Note = node.FinalAction
            ? node.Note
            : joinDefined(
                  [
                      node.Note,
                      toBePlaced && 'Placed: ' + toBePlaced,
                      node.WhereToBeReturned &&
                          (!node.WhereToBeReturned.toLowerCase().includes('return')
                              ? 'Return to ' + node.WhereToBeReturned
                              : node.WhereToBeReturned)
                  ],
                  '\n'
              );
        data.ToBePlaced = null;
        data.WhereToBeReturned = null;
    }
    if (undefined !== data.FinalAction)
        data.FinalAction =
            node.FinalAction || (toBeReturned || toReturn ? 'Return' : toBePlaced && !toReturn ? 'Remain' : null);
    return data;
}

function EditValuables({ form, classes, noChanging }) {
    const isSigned = form.getField('Signed');
    const currLoc = form.getField('CurrentLocation');
    const locationPlaceholder = VALUABLES_LOCATION_QUESTIONS.find(opt => opt.value === (currLoc || 'Awaiting Delivery'))
        .label;
    return (
        <>
            <Grid bucket>
                {form.getField('ID') > 0 && (
                    <Grid item xs={12}>
                        <Checkbox name="Signed" label="Item is signed on Valuables Form" form={form} />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <TextField
                        required={true}
                        name="Description"
                        label="Item Description"
                        placeholder="Enter description of the item..."
                        form={form}
                        InputLabelProps={{ shrink: true }}
                        readOnly={isSigned || noChanging}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        required={true}
                        name="Quantity"
                        label="Item quantity"
                        form={form}
                        type={'number'}
                        inputProps={{ min: '1' }}
                        readOnly={isSigned || noChanging}
                    />
                </Grid>
                <Grid item xs={12} sm={isSigned || noChanging ? 6 : 12}>
                    <RadioGroup
                        form={form}
                        name="FinalAction"
                        label="Final Action"
                        options={VALUABLES_RETURN_OPTIONS}
                        readOnly={isSigned || noChanging}
                    />
                </Grid>
                <Grid pc={1}>
                    {!isSigned ? (
                        <OptionalTextField
                            name="Note"
                            label="Notes"
                            buttonlabel={'+ Add Notes'}
                            placeholder={'Enter any notes...'}
                            form={form}
                            multiline={true}
                        />
                    ) : (
                        <TextField readOnly label="Notes" value={form.getField('Note')} />
                    )}
                </Grid>
            </Grid>

            <Grid bucket>
                <Grid pc={1}>
                    <Label>Current location of the valuable</Label>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Select
                        required={true}
                        name={'CurrentLocation'}
                        form={form}
                        options={VALUABLES_LOCATION_OPTIONS}
                        label="Where is it now"
                        allowNone={false}
                    />
                </Grid>
                <Grid item xs={12} sm={8}>
                    <TextField
                        name="CurrentLocationDetail"
                        label={locationPlaceholder}
                        placeholder={locationPlaceholder}
                        form={form}
                    />
                </Grid>
                {!!form.getField('Changes') && form.getField('Changes').length > 0 && (
                    <Grid pc={1}>
                        <div className={classes.historyDiv}>
                            <Stepper
                                style={{
                                    flexDirection: 'column',
                                    display: 'flex',
                                    padding: 0,
                                    backgroundColor: 'transparent'
                                }}
                                orientation={'vertical'}
                                activeStep={0}
                            >
                                {form
                                    .getField('Changes')
                                    .map((e, i, a) => (
                                        <StepperStep key={i}>
                                            <StepperStepLabel StepIconProps={{ icon: 1 + i }}>
                                                {
                                                    (
                                                        VALUABLES_LOCATION_OPTIONS.find(
                                                            o => o.value === e.Location
                                                        ) || { label: 'Missing' }
                                                    ).label
                                                }
                                                {!!e.LocationDetail && ': '}
                                                {e.LocationDetail}
                                                <br />
                                                <small>
                                                    Entered by {e.UserName}, {niceDateTimeFromString(e.Created)}
                                                </small>
                                            </StepperStepLabel>
                                        </StepperStep>
                                    ))
                                    .reverse()}
                            </Stepper>
                        </div>
                    </Grid>
                )}
            </Grid>
        </>
    );
}

const styles = ({ breakpoints }) => ({
    historyDiv: {
        [breakpoints.up('md')]: {
            overflow: 'auto',
            maxHeight: 320
        }
    }
});
export default withStyles(styles)(EditValuables);
